import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MultipleCriteria } from '../../shared/interfaces/multiple-criteria.interface';
import { SingleMultipleCriteria } from '../../shared/interfaces/singleMultipleCriteria.interface';
import { JwtService } from '../index.service';
import { SingleMultiCriteriaQuestion } from 'src/app/shared/interfaces/single-multi-criteria-question';
import { ISingleLikertQuestion, ISingleSortingQuestion } from 'src/app/shared/interfaces/index.interface';
import { distinctUntilChanged, filter, map, mergeMap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CriteriaService {
    readonly BASE_URL = environment.QUIZ_API_URL;
    quizDetail:any;
    CanExit:boolean=false
    constructor(
        private http:HttpClient,
        public jwtService:JwtService
    ) {}
    getMultiCriteriaList(){
        return this.http.get<MultipleCriteria>(`${this.BASE_URL}multiple_criteria/`);
    }
    getSingleMultiCriteria(username:string){
        return this.http.get<SingleMultipleCriteria>(`${this.BASE_URL}multiple_criteria/${username}/`);
    }
    getSingleMultiCriteriaQuestion(username:string ) {
        return this.http.get<(ISingleLikertQuestion|ISingleSortingQuestion)[]>(`${this.BASE_URL}multiple_criteria/${username}/question/`);
    }
    getMultiCriteriaResults(sorting_username:string,results:any){
        return this.http.post<any>(`${this.BASE_URL}multiple_criteria/api/${sorting_username}/save/`,results);
    }
    sendMultiCriteriaQuestionComment(form:FormData){
        return this.http.post<any>(`${this.BASE_URL}multiple_criteria/comment/`,form);
    }
    getMultiCriteriaSingleResult(url_encode:string){
        return this.http.get<any>(`${this.BASE_URL}multiple_criteria/api/result/exam/encoded/${url_encode}/`)
    }
    getSingleMultiCriteriaCharType(username:string) {
        return this.http.get<any>(`${this.BASE_URL}multiple_criteria/${username}/char-type/`);
    }
    getAllMultipleCriteriaExamResults(username:string) {
        return this.http.get<any>(`${this.BASE_URL}multiple_criteria/result/?user_username=${username}`);
    }
    getSingleMultipleCriteriaExamResults(id:string) {
        return this.http.get<any>(`${this.BASE_URL}multiple_criteria/result/${id}/`);
    }
    getSpeceficOption(id:number){
        return this.http.get<any>(`${this.BASE_URL}multiple_criteria/auth/option/${id}/`);
    }
    takeATest(quizUserName:string, form:any){
        return this.http.post<any>(`${this.BASE_URL}multiple_criteria/${quizUserName}/take_a_test/`, form);
    }
    postVagueQuestions(quizUserName:string, form:FormData){
        return this.http.post<any>(`${this.BASE_URL}multiple_criteria/${quizUserName}/ambiguity_question/`, form);
    }
    getQuizCharts(id:string){
        // return this.http.get<any>(`${this.BASE_URL}multiple_criteria/result/${id}/graph/`);
        return this.http.get<any>(`${this.BASE_URL}multiple_criteria/${id}/graph/`)
    }
    getChartInfo(quizUserName:string, chartId:number, returnedResultId:string){
        return this.http.get<any>(`${this.BASE_URL}multiple_criteria/${quizUserName}/graph/${chartId}/result/${returnedResultId}/`)
    }
    sendQuestionComment(quizUserName:string, questionId:number, form:FormData){
        return this.http.post<any>(`${this.BASE_URL}multiple_criteria/${quizUserName}/question/${questionId}/comment/`, form)
    }
    getMcGraphList(username:string){
        return this.http.get(`${this.BASE_URL}multiple_criteria/${username}/graph/`)
    }
    getSingleMcGraph(username:string,id:number){
        return this.http.get(`${this.BASE_URL}multiple_criteria/${username}/graph/${id}/`)
    }
    getSingleRsultMcGraph(username:string,id:number,result_id:string){
        return this.http.get(`${this.BASE_URL}multiple_criteria/${username}/graph/${id}/result/${result_id}/`)
    }
    isTestedExamObs(examUsername:string){
        return this.jwtService.getCurrentAccountDataObs().pipe(
        filter((account:any)=>account && account.username),
        map(account=>account.username),
        distinctUntilChanged(),
        mergeMap((username:string)=>{
            return this.http.get<any>(`${this.BASE_URL}multiple_criteria/result/?ordering=-created_at&user_username=${username}&exam__username=${examUsername}`)
        })
        )
    }
}
